import { getInitialState, getPath } from "../../utils";

const initialState = {
  appReleasesList: [],
  activeAppRelease: {},
  prevPage: -1,
  nextPage: -1,
  activeFilters: {},
  currentPage: 1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_APP_RELEASES_LIST":
      return setAppReleasesList(state, action);
    case "SET_ACTIVE_APP_RELEASE":
      return setActiveAppRelease(state, action);
    case "SET_ACTIVE_APP_RELEASES_FILTERS":
      return setAppReleasesFilters(state, action);
    case "RESET_STATE_DRIVER_APP_RELEASES":
      return resetState(state, action);
    case "SET_CURRENT_PAGE_APP_RELEASES":
      return setCurrentPageAppReleases(state, action);
    default:
      return state;
  }
}

const setAppReleasesList = (state, action) => {
  return {
    ...state,
    appReleasesList: getPath(action.payload, "releases", []),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
  };
};

const setCurrentPageAppReleases = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setActiveAppRelease = (state, action) => {
  return {
    ...state,
    activeAppRelease: action.payload,
  };
};

const setAppReleasesFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
